import { render, staticRenderFns } from "./DomainBookables.vue?vue&type=template&id=f335945e&"
import script from "./DomainBookables.vue?vue&type=script&lang=js&"
export * from "./DomainBookables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports